import { TenantSubscription } from '../../entities/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleDomain, SecurityModuleName, SecurityRight } from '../security.module';


export enum AppSecurityRight {
    LoginWeb = 1,
    LoginField = 2,
    LoginClient = 3,
    LoginContractor = 4,
    LoginManager = 5,

    FeatureSupervisor = 200,
    FeatureScheduler2 = 201,
    FeatureJobRoles = 202,
    FeatureBillTo = 203
}

export class AppSecurityModule extends BaseSecurityModule<AppSecurityRight> {

    constructor() {

        super(
            SecurityModuleName.Application,
            [
                { _id: AppSecurityRight.LoginWeb, name: 'Log in Web', basic: true },
                { _id: AppSecurityRight.LoginField, name: 'Log in using Field Application', basic: true },
                { _id: AppSecurityRight.LoginClient, name: 'Log in using Client Portal', basic: true, module: SecurityModuleName.PortalContractors },
                { _id: AppSecurityRight.LoginContractor, name: 'Log in using Contractor Portal', basic: true, subscription: TenantSubscription.Enterprise },
                { _id: AppSecurityRight.LoginManager, name: 'Log in using Manager Application', basic: true, subscription: TenantSubscription.Professional },
                // { _id: AppSecurityRight.FeatureBillTo, name: 'Using BillTo for invoicing', basic: true },
                // { _id: AppSecurityRight.LoginClient, name: 'Log in Client', basic: true }
            ] as SecurityRight<AppSecurityRight>[],
            SecurityModuleDomain.Global,
            TenantSubscription.System
        );
    }

}
